export const getDeviceRAM = (): number | null => window.navigator.deviceMemory || null;
